import { motion } from 'framer-motion';
import './PreparacionOposiciones.css';

export default function PreparacionOposiciones() {
  const caracteristicas = [
    "Horarios adaptables",
    "Planificación online + entrenamientos presenciales (2 días/semana)",
    "Máximo 4 personas por grupo",
    "Uso libre de instalaciones"
  ];

  return (
    <div className="opos-container">
      <motion.h1 
        className="opos-title"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        PREPARACIÓN OPOSICIONES
      </motion.h1>

      <motion.div 
        className="opos-section"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.4, duration: 0.8 }}
      >
        <h2>Descripción:</h2>
        <p>
          Planificación y evaluación personalizada orientada a pruebas físicas de acceso por oposición.
        </p>
      </motion.div>

      <motion.div 
        className="opos-section"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.6, duration: 0.8 }}
      >
        <h2>Características:</h2>
        <ul className="opos-list">
          {caracteristicas.map((item, index) => (
            <li key={index}>{item}</li>
          ))}
        </ul>
      </motion.div>

      <motion.div 
        className="opos-section"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.8, duration: 0.8 }}
      >
        <h2>Precio mensual por persona:</h2>

        <div className="opos-precios">
          <div className="opos-precio-cell">
            <p className="opos-amount">130 €</p>
            <p className="opos-desc">
              (Incluye 10% de descuento en fisioterapia y rehabilitación de lesiones)
            </p>
          </div>
        </div>
      </motion.div>
    </div>
  );
}
